export const themeOptionFactory = (theme) => ({
  assets: {
    empty: {
      tourist: {
        icon_path:
          "M22.3588 5.74761H19.7807V1.82814C19.7807 0.820083 18.9606 0 17.9526 0H15.5151C14.507 0 13.6869 0.820083 13.6869 1.82814V5.74761H11.1088C10.3267 5.74761 9.67117 6.29779 9.50771 7.03129H6.98442C5.97636 7.03129 5.15628 7.85137 5.15628 8.85943V10.4351H1.64063C0.735989 10.4351 0 11.1711 0 12.0758V20.9533C0 21.7783 0.612285 22.4628 1.40626 22.5769V23.2969C1.40626 23.6852 1.72107 24 2.10939 24C2.4977 24 2.81252 23.6852 2.81252 23.2969V22.5939H10.8744V23.2969C10.8744 23.6852 11.1892 24 11.5775 24C11.9658 24 12.2807 23.6852 12.2807 23.2969V22.5939H15.9376V23.2969C15.9376 23.6852 16.2525 24 16.6408 24C17.0291 24 17.3439 23.6852 17.3439 23.2969V22.5939H21.187V23.2969C21.187 23.6852 21.5018 24 21.8901 24C22.2784 24 22.5932 23.6852 22.5932 23.2969V22.5769C23.3872 22.4628 23.9995 21.7783 23.9995 20.9532V7.38825C23.9995 6.4836 23.2635 5.74761 22.3588 5.74761ZM13.6869 21.1876V7.15387H19.7807V21.1876H13.6869ZM15.0932 1.82814C15.0932 1.59549 15.2824 1.40626 15.5151 1.40626H17.9526C18.1852 1.40626 18.3745 1.59549 18.3745 1.82814V5.74761H15.0932V1.82814ZM10.8744 7.38825C10.8744 7.25901 10.9795 7.15387 11.1088 7.15387H12.2807V21.1876H11.1088C10.9795 21.1876 10.8744 21.0825 10.8744 20.9532V7.38825ZM9.46815 11.8414V20.9532C9.46815 21.0328 9.47415 21.1111 9.48516 21.1877H4.21882V11.8414H9.46815ZM6.56258 8.85943C6.56258 8.62679 6.75187 8.43755 6.98446 8.43755H9.4682V10.4351H6.56258V8.85943ZM1.40631 12.0758C1.40631 11.9465 1.51145 11.8414 1.64068 11.8414H2.81256V21.1877H1.64068C1.51145 21.1877 1.40631 21.0825 1.40631 20.9533V12.0758ZM22.5932 20.9532C22.5932 21.0825 22.4881 21.1876 22.3588 21.1876H21.187V7.15387H22.3588C22.4881 7.15387 22.5932 7.25901 22.5932 7.38825V20.9532Z",
      },
    },
  },
  components: {
    EmTouristPage: {
      styleOverrides: {
        gridItem: {
          display: "block",
          height: "262px",
          aspectRatio: "1 / 1.25",
          boxShadow: "0px 8px 24px 0px rgba(155, 155, 155, 0.15)",
          "& .MuiCardHeader-root .MuiCardHeader-title": {
            lineHeight: 1.3,
          },
          "& .MuiCardHeader-title": {
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            marginBottom: theme.spacing(0.1875),
            color: theme.palette.text.primary,
            paddingRight: theme.spacing(5.25),
            fontSize: "min(1.125rem, 3vw)",
            textTransform: "uppercase",
            "&:before": {
              content: "''",
              width: "30%",
              position: "absolute",
              borderTop: `1px solid ${theme.palette.divider}`,
              marginTop: theme.spacing(0.5),
              bottom: "24px",
            },
          },
          "& .MuiCardHeader-avatar .MuiAvatar-root": {
            width: "50px",
            height: "50px",
          },
          "& .MuiCardActionArea-root": {
            "&:after": {
              display: "none",
            },
          },
          "& .MuiCardHeader-root": {
            height: "35%",
            padding: theme.spacing(1, 4, 0),
            background: "#fff",
            alignItems: "flex-start",
            position: "relative",
            "& .location-text": {
              position: "absolute",
              bottom: 0,
              right: 0,
              padding: theme.spacing(0.5, 1.25),
              overflow: "hidden",
              background: theme.palette.common.black,
              color: theme.palette.common.white,
              marginLeft: "auto",
              width: "42px",
              height: "38px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderTopLeftRadius: "20px",
              fontSize: "1.2rem",
            },
            "& .MuiCardHeader-content": {
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
              marginBottom: theme.spacing(-0.5),
              marginRight: theme.spacing(-0.5),
            },
          },
          "& .MuiCardMedia-img": {
            width: "100%",
            height: "65%",
            backgroundColor: theme.palette.secondary.main,
          },
        },
        venueSelector: {
          position: "fixed",
          bottom: "175px",
          right: "690px",
          zIndex: 2,
        },
        contentWrapper: {
          height: "100%",
        },
        emptyDataWrapper: {
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "250px",
        },
        gridContainer: {
          position: "relative",
          display: "grid",
          gridAutoFlow: "dense",
          gridTemplateColumns: "repeat(auto-fill, minmax(390px, 1fr))",
          gridTemplateRows: "max-content",
          gap: theme.spacing(2),
          paddingBottom: theme.spacing(6.25),
          overflowY: "auto",
          height: "100%",
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          "@media (max-width: 400px)": {
            gridTemplateColumns: "repeat(auto-fill, minmax(145px, 1fr))",
          },
        },
        pageCard: {
          "&:after": {
            content: "''",
            pointerEvents: "none",
            display: "inline-block",
            position: "absolute",
            zIndex: 1,
            left: 0,
            right: 0,
            bottom: 0,
            minHeight: "180px",
            background:
              "linear-gradient(0deg, #FFF 37.46%, rgba(255, 255, 255, 0.00) 94.07%)",
          },
        },
      },
    },
  },
})
